export default __webpack_public_path__ + "static/media/hand-pointing.0d176f8e.svg";